import {
  BROADCAST_REQUEST,
  BROADCAST_FAILURE,
  FETCH_BROADCASTS_SUCCESS,
  GET_BROADCAST_SUCCESS,
  CREATE_BROADCAST_SUCCESS,
  UPDATE_BROADCAST_SUCCESS,
  DELETE_BROADCAST_SUCCESS,
  FETCH_BROADCAST_CATEGORIES_SUCCESS,
  ADD_BROADCAST_CATEGORY,
  UPDATE_BROADCAST_CATEGORY,
  REMOVE_BROADCAST_CATEGORY,
} from "../action/types";

const initialState = {
  broadcasts: [],
  selectedBroadcast: null,
  categories: [],
  loading: false,
  error: null,
};

const broadcastsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case BROADCAST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BROADCASTS_SUCCESS:
      return {
        ...state,
        loading: false,
        broadcasts:
          payload?.data ??
          (Array.isArray(payload) ? payload : state.broadcasts),
      };

    case GET_BROADCAST_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedBroadcast: payload?.data ?? payload,
      };

    case CREATE_BROADCAST_SUCCESS:
      return {
        ...state,
        loading: false,
        broadcasts: [payload, ...state.broadcasts],
      };

    case UPDATE_BROADCAST_SUCCESS: {
      const updated = payload?.data ?? payload;
      const id = updated?.id || updated?._id;
      return {
        ...state,
        loading: false,
        broadcasts: state.broadcasts.map((b) =>
          (b.id || b._id) === id ? { ...b, ...updated } : b,
        ),
      };
    }

    case DELETE_BROADCAST_SUCCESS:
      return {
        ...state,
        loading: false,
        broadcasts: state.broadcasts.filter((b) => (b.id || b._id) !== payload),
      };

    case FETCH_BROADCAST_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories:
          payload?.data ??
          (Array.isArray(payload) ? payload : state.categories),
      };

    case ADD_BROADCAST_CATEGORY:
      if (
        state.categories.some(
          (cat) => cat.id === payload.id || cat.name === payload.name,
        )
      )
        return state;
      return {
        ...state,
        categories: [payload, ...state.categories],
      };

    case UPDATE_BROADCAST_CATEGORY: {
      const updatedCat = payload?.data ?? payload;
      const catId = updatedCat?.id || updatedCat?._id;
      return {
        ...state,
        categories: state.categories.map((cat) =>
          (cat.id || cat._id) === catId ? { ...cat, ...updatedCat } : cat,
        ),
      };
    }

    case REMOVE_BROADCAST_CATEGORY:
      return {
        ...state,
        categories: state.categories.filter(
          (cat) => cat.id !== payload && cat._id !== payload,
        ),
      };

    case BROADCAST_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default broadcastsReducer;
